import _isEmpty from 'lodash/isEmpty';
export function truncateDescription(description) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 170;
  if (_isEmpty(description)) {
    return '';
  }
  if (description.length <= maxLength) {
    return description;
  }
  var truncated = description.substring(0, maxLength);
  var lastPeriod = truncated.lastIndexOf('.');
  if (lastPeriod === -1) {
    return "".concat(truncated, "...");
  }
  return truncated.substring(0, lastPeriod + 1).trim();
}